// crypto.js - Client-side encryption utilities for Omni Trading Platform

const ENCRYPTION_KEY = import.meta.env.REACT_APP_ENCRYPTION_KEY;

/**
 * Check if a token object is encrypted
 */
export function isEncryptedToken(tokenData) {
  return tokenData && 
         typeof tokenData === 'object' && 
         tokenData.encrypted && 
         tokenData.iv && 
         tokenData.authTag &&
         tokenData.version === '2.0';
}

/**
 * Decrypt an encrypted token file
 * Note: Actual decryption happens on the backend for security
 * This function validates the format
 */
export function decryptTokenFile(encryptedData) {
  if (!isEncryptedToken(encryptedData)) {
    throw new Error('Invalid encrypted token format');
  }
  
  // Return the encrypted data as-is
  // Backend will decrypt and validate it
  return encryptedData;
}

/**
 * Validate token file structure
 */
export function validateTokenFile(tokenData) {
  // Check if it's encrypted format (v2.0)
  if (isEncryptedToken(tokenData)) {
    return {
      valid: true,
      version: '2.0',
      encrypted: true
    };
  }
  
  // Check if it's legacy format (v1.0)
  if (tokenData && typeof tokenData === 'object' && tokenData.token) {
    return {
      valid: true,
      version: '1.0',
      encrypted: false
    };
  }
  
  // Check if it's a plain token string
  if (typeof tokenData === 'string' && tokenData.length > 10) {
    return {
      valid: true,
      version: 'legacy',
      encrypted: false
    };
  }
  
  return {
    valid: false,
    error: 'Invalid token file format'
  };
}

export default {
  isEncryptedToken,
  decryptTokenFile,
  validateTokenFile
};
